export function generateAnglePoints(points) {
  return [
    {
      curr: points[0],
      prev: points[2],
      next: points[1]
    },
    {
      curr: points[1],
      prev: points[0],
      next: points[2]
    },
    {
      curr: points[2],
      prev: points[1],
      next: points[0]
    },
  ]
}